module.exports = __webpack_public_path__ + "static/media/culture.057da2b2.jpg";